<template>
  <v-system-bar color="header-grey" height="67px" class="z-[1] shadow-lg py-5 px-5">
    <router-link to="/">
      <v-img
        alt="Living Evidence Logo"
        class="mr-2"
        contain
        :src="imagePath"
        transition="scale-transition"
        width="180"
        height="40"
      />
    </router-link>
    <div class="flex gap-6 text-base pl-6 flex-1 w-full">
      <div v-for="menuItem in menuHeader" :key="menuItem.path">
        <router-link :to="menuItem.path"> {{ menuItem.name }}</router-link>
      </div>
    </div>
    <div class="flex justify-end items-center gap-4">
      <!-- <ui-settings /> -->
      <ui-user-settings v-if="userIsLogin" />
      <!-- <v-btn v-if="!userIsLogin" @click="$router.push('/login')" small elevation="0" text
        ><v-icon small left>fas fa-sign-in</v-icon> {{ translate("header.signIn") }}</v-btn
      >
      <v-btn
        v-if="!userIsLogin"
        @click="$router.push('/register')"
        small
        elevation="0"
        text
        outlined
        >{{ translate("header.signUp") }}</v-btn
      > -->
    </div>
  </v-system-bar>
</template>

<script>
import uiBreadcrumb from "@/components/ui/uiBreadcrumb.vue";
import { mapGetters } from "vuex";
import UiSettings from "./uiSettings.vue";
import UiUserSettings from "./uiUserSettings.vue";
export default {
  components: { uiBreadcrumb, UiSettings, UiUserSettings },
  computed: {
    ...mapGetters(["isLogin"]),
    userIsLogin() {
      return this.isLogin;
    },
    imagePath() {
      return require("@/assets/img/logos/logos-04.svg");
    },
    menuHeader() {
      return [
        {
          name: this.translate("breadcrumb.about"),
          path: "/about",
        },
        {
          name: this.translate("breadcrumb.manual"),
          path: "/manual",
        },

        {
          name: this.translate("breadcrumb.contact"),
          path: "/contact",
        },
        {
          name: this.translate("breadcrumb.organizations"),
          path: "/organizations",
        },
      ];
    },
  },
};
</script>

<style></style>
